import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { errorMessage } from '../../constants/errorMessage'
import './qrScanCss.scss'
import CommonQr from './CommonQr'
// import { useParams } from 'react-router-dom'
import { isValidPromoCode } from '../../utils/helper'

// PROMOCODE SCANNING QR
function ScanPromoQr(props) {
    const { notify, setIsScanDisplay, setScanResult, scanResult, isDataRecorded, setIsDataRecorded  } = props
    // const {ticketId} = useParams()
    useEffect(() => {
        const handlePopState = () => {
            window.history.pushState(null, document.title, window.location.href)
            setIsScanDisplay(false)
        }

        window.history.pushState(null, document.title, window.location.href)
        window.addEventListener('popstate', handlePopState)

        return () => {
            window.removeEventListener('popstate', handlePopState)
        }
    }, [])

    useEffect(() => {
        if (scanResult && scanResult != null) {
            //    Action for Scann

        }
    }, [scanResult])
    const handleScan = (data) => {
        if (data?.text) {
            if (!isDataRecorded) {
                //Redirect
                if (isValidPromoCode(data?.text)) {
                    setScanResult(data?.text)
                    setIsScanDisplay(false)
                    setIsDataRecorded(true)
                }                
            }else{
                setScanResult(null)
                setIsScanDisplay(true)
            }
            setIsDataRecorded(true)
        } else {
            setIsDataRecorded(false)
        }
    }
    const doNothing = () => { }
    const handleError = (error) => {
        // notify(errorMessage?.somethingWentWrong)
        setIsDataRecorded(true)
        if(JSON.stringify(error + '').includes('Permission denied')) {
            notify('error', 'Please allow the Camera Permission to Scan the QR.')
        } else {
            notify('error', errorMessage?.somethingWentWrong)
        }
    }

    const sendBack = () => {
        setIsScanDisplay(false)
    }
    return (
        <div className={'zIndexHigh top-0 position-fixed bg-white h-100 w-100'}>
            <CommonQr
                isDisplayBack={true}
                handleClose={() => sendBack()}
                isParentCss={false}
                onError={handleError}
                onScan={!isDataRecorded ? handleScan : doNothing}
            />
        </div>
    )
}

ScanPromoQr.propTypes = {
    dispatch: PropTypes.func,
    loader: PropTypes.bool,
    isFetching: PropTypes.bool,
    scanResult: PropTypes.string,
    setScanResult: PropTypes.func,
    notify: PropTypes.func,
    setIsScanDisplay: PropTypes.func,
    handleValidateTicket: PropTypes.func,
    isDataRecorded: PropTypes.bool,
    setIsDataRecorded: PropTypes.func,
    
}

ScanPromoQr.defaulProps = {
    dispatch: noop,
    loader: false,
    isFetching: false,
    scanResult: '',
    setScanResult: noop,
    notify: noop,
    setIsScanDisplay: noop,
    handleValidateTicket: noop,
    isDataRecorded: false,
    setIsDataRecorded: noop,
}

function mapStateToProps({ gatedCheckinReducer }) {
    return {
        loader: gatedCheckinReducer?.loader,
        isFetching: gatedCheckinReducer?.isFetching
    }
}
export default connect(mapStateToProps)(ScanPromoQr)
